import { environment } from '../../environment/environment';

const baseUrl = environment.baseUrl

const endpointsNoLogin = [
    'https://stcp-dev.geolink.pt/payments/checkout-no-login',
    `${baseUrl}mail/send`,
]

export {endpointsNoLogin};